module.exports = __webpack_public_path__ + "img/logo.bb2e975b.svg";